module.exports = __webpack_public_path__ + "img/logo.0d6b44cb.png";